import { Component, OnInit, Input, ViewChild, Output, EventEmitter, TemplateRef } from '@angular/core';
import { trigger, style, state, transition, animate } from '@angular/animations';
import { map } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'takeoff-group-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ])
  ]
})
export class TableComponent implements OnInit {
  @Input('table-header') displayedColumns: string[] = [];
  @Input('table-data') ELEMENT_DATA = [];
  @Input('table-title') tableTitle;
  @Input() isCheckbox: boolean = false;
  @Input() isAllCheckbox: boolean = true;
  @Input() isExpand: boolean = false;
  @Input() showLoader: boolean = false;
  @Input() templateRef: TemplateRef<any>;
  rnavShow: boolean = false;
  dataSource = new MatTableDataSource();
  selection = new SelectionModel(true, []);
  skipValue: number;
  previousIndex: number;
  columns;
  expandedElement: null;
  noData = this.dataSource.connect().pipe(map(data => data.length == 0));

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Output() onCheck = new EventEmitter<boolean>();
  @Output() onCheckAll = new EventEmitter<boolean>();
  @Output() onActionClick = new EventEmitter<any>();
  @Output() onRowExpandClick = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
    this.displayedColumns = [...new Set(this.displayedColumns)];
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.columns = this.displayedColumns.map(item => { return { field: item } });
    this.noData = this.dataSource.connect().pipe(map(data => data.length == 0));
  }

  ngOnChanges() {
    this.displayedColumns = [...new Set(this.displayedColumns)];
    // this.ELEMENT_DATA = this.ELEMENT_DATA.map(m => {
    //   return Object.entries(m).map((i, index) => (index == 1 ? typeof i === 'string' || i instanceof String ? i.replace(/\s\s+/g, ' ') : i : i))
    //     .reduce((obj, [key, value]: any) => { return { ...obj, [key]: value } }, {})
    // });
    this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
    this.skipValue = this.isCheckbox ? 1 : 0;
    (this.isCheckbox && !this.displayedColumns.find(f => f == 'select')) && this.displayedColumns.unshift("select");
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.columns = this.displayedColumns.map(item => { return { field: item } });
    this.noData = this.dataSource.connect().pipe(map(data => data.length == 0));
    this.selection.clear();
  }

  applyFilter(event) {
    const filterValue = event.target?.value;
    this.dataSource.filter = filterValue?.trim().toLowerCase().replace(/\s\s+/g, ' ');
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
      this.isAllSelected() && this.masterToggle();
    }
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
    const selectedRows: any = {
      checkAll: this.isAllSelected(),
      rowData: this.dataSource.filteredData
    };
    this.onCheckAll.emit(selectedRows);
  }

  selectedRow(event, row) {
    let selectedRow: any = {
      checked: event.checked,
      rowData: row
    };
    this.onCheck.emit(selectedRow);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  setDisplayedColumns() {
    this.columns.forEach((colunm, index) => {
      colunm.index = index;
      this.displayedColumns[index] = colunm.field;
    });
  }

  handleAction(type, data) {
    this.onActionClick.emit({ action_type: type, rowData: data });
  }

  onExpandRow(data) {
    this.onRowExpandClick.emit({ rowData: data });
  }
}